import {
  Flex,
  Text,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  UnorderedList,
  ListItem,
  Box,
} from '@chakra-ui/react';

import {RulesIcon2} from '../../icons/RulesIcon2';
import {useTranslate} from '@eksab/i18n';

export const WERulesModal = ({isOpen, onClose}: {isOpen: boolean; onClose: () => void}) => {
  const t = useTranslate();

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          <Flex gap="3">
            <RulesIcon2 />
            <Flex flexDir="column" justifyContent="space-between">
              <Text fontSize="small" color="#8f8f8f" fontWeight="semibold">
                {t('trivia.rules.check_before_playing')}
              </Text>
              <Text fontSize="2xl" fontWeight="bold">
                {t('trivia.rules.we.terms-and-conditions')}
              </Text>
            </Flex>
          </Flex>
        </ModalHeader>
        <ModalBody overflowY="scroll" maxH="600px">
          <Text fontSize="2xl" fontWeight="bold" mb={3}>
            {t('trivia.rules.we.eligibility')}
          </Text>
          <Box mb={3}>
            <UnorderedList>
              <ListItem>{t(`trivia.rules.we.eligibility.1`)}</ListItem>
            </UnorderedList>
          </Box>

          <Text fontSize="2xl" fontWeight="bold" mb={3}>
            {t('trivia.rules.we.how-to-play')}
          </Text>
          <Box mb={3}>
            <UnorderedList>
              <ListItem>{t(`trivia.rules.we.how-to-play.1`)}</ListItem>
              <ListItem>{t(`trivia.rules.we.how-to-play.2`)}</ListItem>
              <ListItem>{t(`trivia.rules.we.how-to-play.3`)}</ListItem>
              <ListItem>{t(`trivia.rules.we.how-to-play.4`)}</ListItem>
              <ListItem>{t(`trivia.rules.we.how-to-play.5`)}</ListItem>
              <ListItem>{t(`trivia.rules.we.how-to-play.6`)}</ListItem>
              <ListItem>{t(`trivia.rules.we.how-to-play.7`)}</ListItem>
            </UnorderedList>
          </Box>

          <Text fontSize="2xl" fontWeight="bold" mb={3}>
            {t('trivia.rules.we.game-duration')}
          </Text>
          <Box mb={3}>
            <UnorderedList>
              <ListItem>{t(`trivia.rules.we.game-duration.1`)}</ListItem>
            </UnorderedList>
          </Box>

          <Text fontSize="2xl" fontWeight="bold" mb={3}>
            {t('trivia.rules.we.getting-the-prize')}
          </Text>
          <Box mb={3}>
            <UnorderedList>
              <ListItem>{t(`trivia.rules.we.getting-the-prize.1`)}</ListItem>
            </UnorderedList>
          </Box>

          <Text fontSize="2xl" fontWeight="bold" mb={3}>
            {t('trivia.rules.we.prize-validity')}
          </Text>
          <Box mb={3}>
            <UnorderedList>
              <ListItem>{t(`trivia.rules.we.prize-validity.1`)}</ListItem>
            </UnorderedList>
          </Box>
        </ModalBody>
        <ModalCloseButton />
      </ModalContent>
    </Modal>
  );
};
